<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import CartaoOrdemDePagamento from './CartaoOrdemDePagamento/CartaoOrdemDePagamento.vue';
import CartaoAprovadores from './CartaoAprovadores/CartaoAprovadores.vue';
import CartaoAprovacao from './CartaoAprovacao/CartaoAprovacao.vue';
import CartaoJob from './CartaoJob/CartaoJob.vue';
// import CartaoRecorrencia from './CartaoRecorrencia/CartaoRecorrencia.vue';
import CartaoJustificativa from './CartaoJustificativa/CartaoJustificativa.vue';
import CartaoDespesas from './CartaoDespesas/CartaoDespesas.vue';
// import CartaoParcelas from './CartaoParcelas/CartaoParcelas.vue';
import CartaoPagamento from './CartaoPagamento/CartaoPagamento.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    dado: {
        type: Object,
        default: () => ({})
    },
    pagamento: {
        type: Object,
        default: () => ({})
    },
    aprovacao: {
        type: Object,
        default: () => ({})
    },
    aprovacaoTipo: {
        type: String,
        default: 'Nenhum'
    },
    aprovadoresParaExibicao: {
        type: Array,
        default: () => ([])
    },
    aprovadorIsAdmin: {
        type: Boolean,
        default: false
    },
    aprovacoesDoTipo: {
        type: Array,
        default: () => ([])
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits([
    'update:alteraAprovacao',
    'update:selecionaAprovacao'
]);

/*==================================================================*/
/*================== ALTERA APROVACAO ==============================*/
/*==================================================================*/

const alteraAprovacao = (update = {}) => {

    emits('update:alteraAprovacao', update);

};

/*==================================================================*/
/*================== SELECIONA APROVACAO ==========================*/
/*==================================================================*/

const selecionaAprovacao = (dado = {}) => {

    emits('update:selecionaAprovacao', dado);

};

</script>

<template>

    <div class="c-conteudo">

        <!--==============================================================-->
        <!--================== CARD ORDEM DE PAGAMENTO ==================-->
        <!--==============================================================-->

        <CartaoOrdemDePagamento
            :dado="props.dado"
        ></CartaoOrdemDePagamento>

        <!--==============================================================-->
        <!--================== CARD APROVADORES ==========================-->
        <!--==============================================================-->

        <CartaoAprovadores
            :dado="props.dado"
            :aprovadoresParaExibicao="props.aprovadoresParaExibicao"
        ></CartaoAprovadores>

        <!--==============================================================-->
        <!--================== CARD APROVAÇÃO ============================-->
        <!--==============================================================-->

        <CartaoAprovacao
            :aprovacao="props.aprovacao"
            :aprovacaoTipo="props.aprovacaoTipo"
            :aprovadorIsAdmin="props.aprovadorIsAdmin"
            :aprovacoesDoTipo="props.aprovacoesDoTipo"
            :disabled="props.disabled"
            @update:alteraAprovacao="alteraAprovacao"
            @update:selecionaAprovacao="selecionaAprovacao"
        ></CartaoAprovacao>

        <!--==============================================================-->
        <!--================== CARD JOB ==================================-->
        <!--==============================================================-->

        <CartaoJob
            v-if="props.dado?.tipo === 'Custo de Job'"
            :dado="props.dado"
        ></CartaoJob>

        <!--==============================================================-->
        <!--================== CARD RECORRENCIA ==========================-->
        <!--================== FUTURO - SERÁ IMPLEMENTADO ================-->
        <!--==============================================================-->

        <!-- <CartaoRecorrencia
            :dado="props.dado"
        ></CartaoRecorrencia> -->

        <!--==============================================================-->
        <!--================== CARD JUSTIFICATIVA =======================-->
        <!--==============================================================-->

        <CartaoJustificativa
            :dado="props.dado"
        ></CartaoJustificativa>

        <!--==============================================================-->
        <!--================== CARD DESPESAS ============================-->
        <!--==============================================================-->

        <CartaoDespesas
            :dado="props.dado"
        ></CartaoDespesas>

        <!--==============================================================-->
        <!--================== CARD PARCELAS ============================-->
        <!--================== FUTURO - SERÁ IMPLEMENTADO ================-->
        <!--==============================================================-->

        <!-- <CartaoParcelas
            :dado="props.dado"
        ></CartaoParcelas> -->

        <!--==============================================================-->
        <!--================== CARD PAGAMENTO ===========================-->
        <!--==============================================================-->

        <CartaoPagamento
            :pagamento="props.pagamento"
        ></CartaoPagamento>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*================== Conteúdo ======================================*/
/*==================================================================*/

.c-conteudo {
    display: grid;
    gap: 16px;
    padding: 24px;
}

</style>
